import { ActionTypes } from './actionTypes';

const initialState = {
  analyticsMetricDefinitions: [],
  highLevelMetricDefinitions: [],
};

const metricDefinitionsReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case ActionTypes.FETCH_ANALYTICS_METRIC_DEFINITIONS_RESPONSE: {
      return {
        ...state,
        analyticsMetricDefinitions: action.response,
      };
    }
    case ActionTypes.FETCH_HIGH_LEVEL_METRIC_DEFINITIONS_RESPONSE: {
      return {
        ...state,
        highLevelMetricDefinitions: action.response,
      };
    }
    default: {
      return state;
    }
  }
};

export default metricDefinitionsReducer;
